import { Stack, Typography } from "@mui/material";
import { type FC, useMemo } from "react";

import { getPercentageStatus } from "~/components/UI/PercentageComponent/utils";
import { formatPercentageValue } from "~/utils/formatValue";

import { COLOR_BY_STATUS, ICON_BY_STATUS } from "./constants";

interface IPercentageComponentProps {
  percentage?: number | null;
  isBold?: boolean;
}

export const PercentageComponent: FC<IPercentageComponentProps> = ({
  percentage,
  isBold = false,
}) => {
  const percText = useMemo(
    () => (percentage == null ? "" : formatPercentageValue(percentage)),
    [percentage]
  );

  const status = useMemo(
    () => (percentage == null ? null : getPercentageStatus(percentage)),
    [percentage]
  );

  if (percentage === null) {
    return (
      <Typography variant="caption" sx={{
        fontWeight: isBold ? 600 : 400
      }}>N/A
              </Typography>
    );
  }

  if (percentage === undefined) {
    return null;
  }

  const color = COLOR_BY_STATUS[status!];
  const Icon = ICON_BY_STATUS[status!];

  return (
    <Stack
      direction="row"
      spacing={0}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        color: color,
        height: "100%"
      }}>
      <Typography variant="caption" sx={{
        fontWeight: isBold ? 600 : 400
      }}>
        {percText}
      </Typography>
      {Icon != null && <Icon sx={{ fontSize: "16px" }} />}
    </Stack>
  );
};
